import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useStyles from './EmptySlotsMsg.styles'
import { CLOCK_AND_CALENDAR_URL } from 'src/config/imageUrls'
import { getImageUrl } from 'src/utils/getImageUrl'
import { posthog } from 'posthog-js'
import getTrackingParams from "src/utils/getTrackingParams";

export const GapFillerEmptySlotsMessage = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const utm_medium = getTrackingParams(window.location)['utm_medium']

  useEffect(() => {
    posthog.capture('Message ‘no more available gaps’ shown', {
      utm_medium: utm_medium,
    })
  }, [utm_medium]);

  return (
    <div className={classes.root}>
      <p className={classes.text}>{t('gap_filler_empty_slots')}</p>
      <img className={classes.image} src={getImageUrl({ src: CLOCK_AND_CALENDAR_URL })} alt={'clock'} />
    </div>
  )
}
